{ getIdsAsList } = require("../../../utils")

module.exports = ($scope, $stateParams, $state, Api, alert) ->
  @initialTags = alert.tags?.slice()

  $scope.alert = alert
  $scope.alerts = []

  $scope.isSource = (subject, targetSource) ->
    source = subject.source or $scope.user.d3_alerts_data_source
    source?.indexOf(targetSource) == 0

  # Hack to create two objects, one with names, and one without.
  # This is so we can show the names on the top of the list,
  # and everything else below it.

  $scope.alertDataWithNames =
    names: $scope.alert.data?.names or $scope.alert.data?.name_details

  $scope.alertDataWithoutNames = {}
  for key, value of $scope.alert.data or {}
    if key not in ["names", "name_details"]
      $scope.alertDataWithoutNames[key] = value

  @dataSourceToLogo =
    anansi: "djrc.png"
    trma: "thomsonreuters.png"
    world_compliance: "worldcompliance.png"

  $scope.getAlertLogo = () =>
    for dataSource, imageFile of @dataSourceToLogo
      if $scope.isSource($scope.subject, dataSource)
        return "/static/dist/images/#{imageFile}"

  @getNewestAlertAfterCurrent = () ->
    # Return the next alert based on the first alert found that is
    # 'newer' than the current, based on ID
    return alert for alert in $scope.alerts when alert.id > $scope.alert.id

  @moveToNextAlert = () =>
    # Get the next alert based on ID
    nextAlert = @getNewestAlertAfterCurrent()
    if nextAlert
      # Transition to the next alert
      $state.go("subject.alert", {
        alertId: nextAlert.id
        subjectId: $stateParams.subjectId
      })
    else
      # If there are no more alerts, return to the subject's alerts overview
      $state.go("subject.alerts", subjectId: $stateParams.subjectId)

  $scope.hasSubjectMetadata = () ->
    $scope.subject?.extra?

  $scope.loading = false

  $scope.moveToNextAlert = () =>
    if $scope.alerts?.length > 0
      # Try to move to the next alert if the alerts cache is populated
      @moveToNextAlert()
    else
      # Otherwise, populate the alerts cache, and try to move again
      $scope.loading = true
      params =
        limit: 100
        subject: $stateParams.subjectId
      if @initialTags?.length is 0
        params.outstanding_only = true
      else
        params.tags = @initialTags
      req = new Api.MonitoringSubjectAlerts.get(params).$promise
      req.then (alerts) =>
        $scope.loading = false
        $scope.alerts = alerts.results
        @moveToNextAlert()
